<template>
  <div class="text-center text-primary my-2">
    <b-spinner class="align-middle mr-2"></b-spinner>
    <strong>Đang lấy số liệu....</strong>
  </div>
</template>
<script>
export default {
  name: "BaseLoadingTable"
};
</script>
